import { useEffect } from "react";
import { API } from "@/lib/api";
import { X, ShieldAlert, Loader2 } from "lucide-react";

export default function FormPreviewModal({ docId, title, code, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const src = `${API}/documents/${docId}/preview#toolbar=0&navpanes=0`;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="form-preview-modal"
    >
      <div
        className="bg-white w-full max-w-4xl h-[90vh] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-4 p-4 border-b border-border">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              {code && <span className="font-mono text-[10px] bg-secondary px-1.5 py-0.5 text-foreground/70">{code}</span>}
              <h2 className="font-heading font-bold text-base truncate">{title || "Form preview"}</h2>
            </div>
            <p className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1.5">
              <ShieldAlert className="w-3.5 h-3.5 text-primary" /> Watermarked preview — not licensed for use. Purchase for a clean, editable copy.
            </p>
          </div>
          <button onClick={onClose} data-testid="form-preview-close" className="text-muted-foreground hover:text-foreground shrink-0">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 relative bg-secondary">
          <div className="absolute inset-0 flex items-center justify-center text-muted-foreground pointer-events-none">
            <Loader2 className="w-6 h-6 animate-spin" />
          </div>
          <iframe
            title="Form preview"
            src={src}
            className="absolute inset-0 w-full h-full"
            data-testid="form-preview-frame"
          />
        </div>
      </div>
    </div>
  );
}
